// 建物一覧のモーダルで選択したIES4ファイルを、IES4取込画面へ引き継ぐための一時保管。
// File オブジェクトはルーターのparams/queryに載せられないため、モジュール変数で受け渡す。
let pendingFile = null;
let pendingBuildingId = null;

export const setPendingIes4File = (file, buildingId) => {
  pendingFile = file;
  pendingBuildingId = String(buildingId);
};

export const clearPendingIes4File = () => {
  pendingFile = null;
  pendingBuildingId = null;
};

// 取り出しは1回限り。対象建物が一致しない場合（直接URLアクセス・別建物への遷移）は渡さない。
export const takePendingIes4File = (buildingId) => {
  if (!pendingFile || pendingBuildingId !== String(buildingId)) {
    clearPendingIes4File();
    return null;
  }

  const file = pendingFile;
  clearPendingIes4File();
  return file;
};
